import { render, staticRenderFns } from "./BriqInventory.vue?vue&type=template&id=4a41f204&scoped=true&lang=pug&"
import script from "./BriqInventory.vue?vue&type=script&lang=js&"
export * from "./BriqInventory.vue?vue&type=script&lang=js&"
import style0 from "./BriqInventory.vue?vue&type=style&index=0&id=4a41f204&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41f204",
  null
  
)

export default component.exports